module.exports = "pegasus_template/assets/themelp1/launch/200.png";